import React, { useContext } from 'react';
import { VBHeight_ZoomMap, VBWidth_ZoomMap } from '../../common/svg';
import { FliterContext } from '../../context/FliterContextProvider';
import { TransitsContext } from '../../context/TransitsContextProvider';
import SvgZoomMap from '../atoms/svg/map/ZoomMap';
import TrainsZoomMap from './svg/TrainsZoomMap';

const ZoomMap_Map: React.FC = () => {
  const { transits } = useContext(TransitsContext);
  const { filter } = useContext(FliterContext);

  return (
    <svg
      width={'100%'}
      height={'100%'}
      viewBox={`0 0 ${VBWidth_ZoomMap} ${VBHeight_ZoomMap}`}
      preserveAspectRatio='xMidYMid meet'
      textRendering='geometricPrecision'
    >
      <SvgZoomMap></SvgZoomMap>

      {/* 動的に追加する要素 */}
      <TrainsZoomMap
        icons={
          filter === 'LowFloor'
            ? transits.icons_zoom_low_floor
            : transits.icons_zoom
        }
      ></TrainsZoomMap>
    </svg>
  );
};

export default React.memo(ZoomMap_Map);
